<template>
  <div class="order-party-wrappper" v-if="info">
    <div class="top-box">
      <!-- 时间进度 条 -->
      <div class="progress-left" v-if="info.etaTime">
        <div class="progress-line-top"></div>
        <div class="status-active"></div>
        <div class="progress-line"></div>
      </div>
      <!-- desc | time -->
      <div class="desc-right">
        <p class="desc-title ellipsis" v-text="info.title"></p>
        <p class="desc-time" v-if="info.etaTime">
          <RichText :text="info.etaTime" />
        </p>
      </div>
    </div>
    <!-- 慢必赔提示 -->
    <div class="word-chain-style" v-if="info.wordChain && info.wordChain.text">
      <WordChain
        :text="info.wordChain.text"
        :url="info.wordChain.url"
        :orderId="orderId"
        :orderStatus="orderStatus"
        :store-delivery="STORE_DELIVERY === nVal"
      />
    </div>
    <ServerCard
      :orderId="orderId"
      :orderStatus="orderStatus"
      :list="info.serverSubject"
    />
  </div>
</template>

<script>
import RichText from '@/components/RichText';
import WordChain from './wordChain.vue';
import ServerCard from './serverCard.vue';
import { STORE_DELIVERY } from '@/const/store'

export default {
  name: 'OrderPartyCard',
  components: {
    RichText,
    WordChain,
    ServerCard,
  },
  props: {
    info: Object,
    orderId: String,
    orderStatus: Number,
    deliveryType: Number
  },
  data() {
    return {
      STORE_DELIVERY: STORE_DELIVERY
    };
  },
  watch: {
    info(nVal, oVal) {
      if (nVal !== oVal) {
        this.init(nVal);
      }
    },
  },
  created() {
    this.init(this.info);
  },
  methods: {
    init(nVal) {
      this.$trackEvent({
        eventId: 'sailing_c_x_order_service_sw',
        eventLabel: '订单服务卡片曝光慢必赔',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus,
          order_tips: nVal?.wordChain?.text || '',
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
